<template>
    <div class="d-flex flex-column">

        <table class="table table-striped">
            <thead>
                <th class="text-center" v-for="(head, index) in headers" :key="index">
                    {{ head }}
                </th>
            </thead>

            <tbody>
                <tr v-for="(_, index_tr) in numberRows"  :key="index_tr">
                    <td class="text-center" v-for="(body, index) in headers" :key="index">
                        <div class="d-flex justify-content-center card-text placeholder-glow">
                            <div class="txt_loader"></div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>
</template>

<script>
export default {
   props : {
    numberRows : { type : Number},
    headers : { type : Array}
   }

}
</script>

<style>

    .circular_skeleton{
        border-radius: 50px;
        height: 55px;
        width: 55px;
        background: rgb(201, 201, 201);
    }

    .line_booking{
        min-height: 3px !important;
        width: 70px !important;
        background: rgb(201, 201, 201) !important;
        border-radius: 10px !important;
        margin: 0px 5px !important;
        margin-top: -10px !important;
    }

    .txt_loader{
        height: 10px;
        width: 55px;
        background: rgb(201, 201, 201);
        border-radius: 1px;
        margin-top: 5px;
        animation: placeholder-glow 2s ease-in-out infinite;
    }

</style>